import * as borogove from "borogove";
import encodeQR from "qr";
import {
	Button,
	ChatContainer,
	MessageList,
} from "@chatscope/chat-ui-kit-react";
import { CircularProgress } from "@mui/material";
import { useOutletContext } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

import { AvatarWithPlaceholder } from "./AvatarWithPlaceholder";
import { AwaitOnce } from "./AwaitOnce";
import { Profile } from "./Profile";
import { confirmDialog } from "./ConfirmDialog";

export const Account = () => {
	const { active, client, status, setStatus, logout } = useOutletContext<{
		active: boolean;
		client: borogove.Client;
		status: string;
		setStatus: (status: string) => void;
		logout: (completely: boolean) => void;
	}>();
	const self = client
		.getChat(client.accountId())
		?.getParticipantDetails(client.accountId());

	const confirmThenLogout = () => {
		confirmDialog({
			message:
				"Do you want to also delete all chats and messages from this device?",
			accept: () => logout(true),
			reject: () => logout(false),
		});
	};

	return (
		<ChatContainer className={active ? "active" : undefined}>
			<MessageList className="account">
				<MessageList.Content>
					<h1>Account Details</h1>
					<code>{client.accountId()}</code>

					<AvatarWithPlaceholder
						displayName={client.displayName()}
						placeholderUri={self?.placeholderUri}
						photoUri={self?.photoUri}
					/>

					<form
						onSubmit={(e) => {
							e.preventDefault();
							client.setDisplayName(e.currentTarget.fn.value);
						}}
					>
						<input
							key={"nicknameWithDefault" + client.displayName()}
							type="text"
							name="fn"
							autoComplete="nickname"
							defaultValue={client.displayName()}
						/>
						<button>Save</button>
					</form>

					{self && (
						<AwaitOnce
							key={client.accountId()}
							resolve={() => self.profile(client)}
							fallback={<CircularProgress />}
						>
							{(profile) => <Profile profile={profile} />}
						</AwaitOnce>
					)}

					<Button
						icon={<FontAwesomeIcon icon={faRightFromBracket} />}
						onClick={confirmThenLogout}
					>
						Remove this account
					</Button>

					{status === "auth" && (
						<form
							onSubmit={(e) => {
								e.preventDefault();
								client.usePassword(e.currentTarget.password.value);
								setStatus("connecting");
							}}
						>
							Please enter your password again:
							<input type="password" name="password" />
							<button>Login</button>
						</form>
					)}

					<div
						className="qrcode"
						dangerouslySetInnerHTML={{
							__html: encodeQR(
								"xmpp:" + encodeURIComponent(client.accountId()),
								"svg",
								{ ecc: "high" },
							),
						}}
					/>
				</MessageList.Content>
			</MessageList>
		</ChatContainer>
	);
};
